import { BreadcrumbItem } from "@/types/breadcrumb";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { PATH_PROJECTS, PATH_ROOT } from "@/constants";
import { generateDisplayName } from "@/modules/projects/lib/generateDisplayName";
import { generatePath } from "react-router-dom";
import { PATH_PROJECT_RATES } from "@/constants";
import { useProjectQuery } from "@/modules/projects/hooks/useProjectQuery";
import { useProjectId } from "@/modules/projects/hooks/useProjectId";

export const useProjectRateBreadcrumbs = () => {
  const { t } = useTranslation();
  const title = t("projectRates.title.add");
  const projectId = useProjectId();
  const projectQuery = useProjectQuery(projectId);

  const breadcrumbItems = useMemo(() => {
    const breadcrumbItems: BreadcrumbItem[] = [
      { label: t("breadcrumb.home"), href: PATH_ROOT },
      { label: t("projects.breadcrumb.projects"), href: PATH_PROJECTS },
    ];

    breadcrumbItems.push({
      label: t("projects.breadcrumb.project", {
        name:
          projectQuery.data !== undefined
            ? generateDisplayName(projectQuery.data)
            : "...",
      }),
      href: `${PATH_PROJECTS}/${projectId}`,
    });

    breadcrumbItems.push({
      label: t(`projects.breadcrumb.rates`),
      href: generatePath(PATH_PROJECT_RATES, { projectId }),
    });

    breadcrumbItems.push({
      label: title,
    });
    return breadcrumbItems;
  }, [t, projectId, projectQuery.data, title]);

  return breadcrumbItems;
};
